import { AbstractControl } from '@angular/forms'
import { Arn } from './types'

export function sanitizeAwsAccountId(accountId: string) {
  let sanitized = ''
  for (let c of accountId) {
    if (c >= '0' && c <= '9') {
      sanitized += c
    }
  }
  return sanitized
}
export function validAwsAccountId(accountId: string) {
  // may need to beef this up
  return !!accountId && accountId.length == 12
}

export function sanitizeAwsRegion(region: string) {
  return region.trim()
}

// Fallback hardcoded regions for backwards compatibility and offline scenarios
// Sorted in AWS console style: US East 1/2, US West 1/2, then Asia Pacific, Canada, Europe, Middle East, Africa, South America, Israel - all alphabetical within groups
const fallbackAwsRegions = [
  'us-east-1',
  'us-east-2',
  'us-west-1',
  'us-west-2',
  'ap-east-1',
  'ap-northeast-1',
  'ap-northeast-2',
  'ap-northeast-3',
  'ap-south-1',
  'ap-south-2',
  'ap-southeast-1',
  'ap-southeast-2',
  'ap-southeast-3',
  'ap-southeast-4',
  'ca-central-1',
  'ca-west-1',
  'eu-central-1',
  'eu-central-2',
  'eu-north-1',
  'eu-south-1',
  'eu-south-2',
  'eu-west-1',
  'eu-west-2',
  'eu-west-3',
  'af-south-1',
  'me-central-1',
  'me-south-1',
  'sa-east-1',
  'il-central-1',
  /* Not supported regions
    'us-gov-east-1',
    'us-gov-west-1'
    'cn-north-1',
    'cn-northwest-1',
    */
]

/**
 * @deprecated Use RegionsService.getAwsRegions() instead for dynamic regions from API
 * This constant is kept for backwards compatibility only
 */
export const awsRegions = fallbackAwsRegions

/**
 * @deprecated Use RegionsService.isValidAwsRegion() instead for dynamic validation
 */
export function validAwsRegion(region: string) {
  return !!region && fallbackAwsRegions.find((r: string) => r === region) !== undefined
}

export function wellFormedAwsAccountId(control: AbstractControl) {
  let awsAccountId = sanitizeAwsAccountId(control.value)
  let valid = awsAccountId === '' || validAwsAccountId(awsAccountId)
  return valid ? null : { malformedAccountId: awsAccountId }
}

export function wellFormedAwsRegion(control: AbstractControl) {
  let region = sanitizeAwsRegion(control.value)
  let valid = validAwsRegion(region)
  return valid ? null : { malformedRegion: region }
}

export var minPasswordLength = 12

export function parseArn(arn: Arn) {
  const segments = arn.split(':')
  const [, partition, service, region, accountId, ...resource] = segments
  return { partition, service, region, accountId, resource }
}

export function consoleUrl(arn: Arn): string {
  const x = parseArn(arn)
  const baseUrl = `https://${x.region}.console.${x.partition}.amazon.com/`
  switch (x.service) {
    case 'eks': {
      const resource = x.resource[0].split('/')
      switch (resource[0]) {
        // arn:aws:eks:us-east-1:406509977758:cluster/iam-test
        // https://us-east-1.console.aws.amazon.com/eks/home?region=us-east-1#/clusters/iam-test
        case 'cluster': {
          return baseUrl + `${x.service}/home?region=${x.region}#/clusters/${resource[1]}`
        }
        // arn:aws:eks:us-east-1:406509977758:nodegroup/iam-test/ng01/d4c554be-e759-894a-bc36-bc1509f961c8
        // https://us-east-1.console.aws.amazon.com/eks/home?region=us-east-1#/clusters/iam-test/nodegroups/ng01
        case 'nodegroup': {
          return baseUrl + `${x.service}/home?region=${x.region}#/clusters/${resource[1]}/nodegroups/${resource[2]}`
        }
      }
      return undefined // matched eks, but not the sub resource
    }
    // arn:aws:secretsmanager:us-east-1:406509977758:secret:MySecret-AZpJx4
    // https://us-east-1.console.aws.amazon.com/secretsmanager/secret?name=MySecret&region=us-east-1#
    case 'secretsmanager': {
      return baseUrl + `${x.service}/${x.resource[0]}?name=${x.resource[1].slice(0, -7)}&region=${x.region}#`
    }
  }
  // intentionally return undefined if we don't match a case above
}
